import { AccessLevel } from '@kcftech/prometheus-client';
import { ArrowLinkEditorRenderer } from 'components/link/ArrowLink';
import { usePermissions } from 'contexts/PermissionsContext';
import { useCorporation } from 'custom_hooks/data_hooks/corporation/useCorporation';
import { LocationNameInlineEditor } from 'pages/Settings/Locations/LocationNameInlineEditor';
import { LocationsTableCellProps } from 'pages/Settings/Locations/LocationsTable';
import { FullWidthWrapper } from 'pages/Settings/shared/styled';
import { useMemo } from 'react';
import { getSingleLocationRoute } from 'utils/RouteHelper';

export function LocationNameCell({
    rowData,
    onChange,
}: LocationsTableCellProps & Readonly<{ arrowLink?: boolean }>) {
    const { data: corporation } = useCorporation(rowData.Corporation.CorporationId);
    const { canViewLocationDetails, canEditLocationDetails } = usePermissions();

    const hasAccessToDetailsPage = useMemo(
        // no matter the Access Level, SaaS/Global Admins should be able to see the Location Details page,
        // if its Premium, sentry users should also be able to view location details
        () =>
            (corporation?.AccessLevel === AccessLevel.Premium &&
                canViewLocationDetails) ||
            canEditLocationDetails,
        [canEditLocationDetails, canViewLocationDetails, corporation?.AccessLevel],
    );

    return (
        <>
            {hasAccessToDetailsPage ? (
                <LocationNameInlineEditor
                    location={rowData}
                    onChange={onChange}
                    renderValue={(value) => (
                        <ArrowLinkEditorRenderer
                            value={value}
                            to={getSingleLocationRoute(rowData.Id)}
                            title="Select location"
                        />
                    )}
                />
            ) : (
                <FullWidthWrapper>
                    <LocationNameInlineEditor location={rowData} onChange={onChange} />
                </FullWidthWrapper>
            )}
        </>
    );
}
